import { useEffect, useState } from "react";
import {
  collection,
  onSnapshot,
  query,
  orderBy,
  where,
  Timestamp,
} from "firebase/firestore";
import { db } from "../firebase";
import { Room } from "../types/types";

export function useRooms() {
  const [rooms, setRooms] = useState<Room[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    setError(null);

    const roomsRef = collection(db, "rooms");
    const now = Timestamp.now();
    const twentyMinutesAgo = new Timestamp(
      now.seconds - 20 * 60, // Show rooms that are already started 20 minutes ago
      now.nanoseconds,
    );
    const q = query(
      roomsRef,
      where("startAt", ">=", twentyMinutesAgo),
      orderBy("startAt", "asc"),
    );

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const roomsData: Room[] = [];
        snapshot.forEach((doc) => {
          const data = doc.data();
          roomsData.push({
            id: doc.id,
            channelName: data.channelName || data.name || "",
            name: data.name || "",
            createdBy: data.createdBy || "",
            createdAt: data.createdAt?.toDate() || new Date(),
            startAt:
              data.startAt?.toDate() || data.createdAt?.toDate() || new Date(),
            status: data.status || "active",
            topics: Array.isArray(data.topics) ? data.topics : [],
            participants: Array.isArray(data.participants)
              ? data.participants
              : [],
            openDoorAt: data.openDoorAt?.toDate() || new Date(),
            endAt: data.endAt?.toDate() || new Date(),
            alertBeforeEndAt: data.alertBeforeEndAt?.toDate() || new Date(),
            maxParticipants:
              typeof data.maxParticipants === "number"
                ? data.maxParticipants
                : undefined,
          });
        });
        setRooms(roomsData);
        setLoading(false);
      },
      (error) => {
        console.error("Error fetching rooms:", error);
        setError(error.message);
        setLoading(false);
      },
    );

    return () => {
      unsubscribe();
    };
  }, []);

  return { rooms, loading, error };
}
